var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height pa-0",attrs:{"max":"","fluid":""}},[_c('v-row',{staticClass:"pr-0 mx-0",staticStyle:{"height":"100%"},attrs:{"id":"map"}},[_c('v-col',{staticClass:"pt-0 pr-0 pb-0 pl-0"},[_c('reports-map'),_c('dashboard-navigation')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }